/* ════════════════════════════════════════════════
   RATHNAM OIL — PRODUCT PAGE JS v3
   Fully dynamic: gallery, variants, ATC, lightbox
════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── helpers ── */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* ═══════════════════════════════════
     1. GALLERY
  ═══════════════════════════════════ */
  var slides   = qsa('.rp-slide');
  var thumbs   = qsa('.rp-thumb');
  var dots     = qsa('.rp-dot');
  var counter  = qs('#rp-counter');
  var total    = slides.length;
  var current  = 0;

  function goTo(n, skipLb) {
    if (total === 0) return;
    slides[current].classList.remove('rp-slide--active');
    if (thumbs[current]) thumbs[current].classList.remove('rp-thumb--active');
    if (dots[current])   dots[current].classList.remove('rp-dot--active');

    current = ((n % total) + total) % total;

    slides[current].classList.add('rp-slide--active');
    if (thumbs[current]) {
      thumbs[current].classList.add('rp-thumb--active');
      thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
    if (dots[current]) dots[current].classList.add('rp-dot--active');
    if (counter) counter.textContent = (current + 1) + ' / ' + total;

    /* update lightbox counter */
    var lbCount = qs('#rp-lb-count');
    if (lbCount) lbCount.textContent = (current + 1) + ' / ' + total;
  }

  /* Arrow buttons */
  on(qs('#rp-prev'), 'click', function () { goTo(current - 1); });
  on(qs('#rp-next'), 'click', function () { goTo(current + 1); });

  /* Thumb clicks */
  thumbs.forEach(function (th) {
    on(th, 'click', function () { goTo(parseInt(th.dataset.thumb, 10)); });
  });

  /* Dot clicks */
  dots.forEach(function (d) {
    on(d, 'click', function () { goTo(parseInt(d.dataset.dot, 10)); });
  });

  /* Touch / swipe on stage */
  var stage = qs('#rp-stage');
  var swipeStartX = 0;
  on(stage, 'touchstart', function (e) { swipeStartX = e.touches[0].clientX; }, { passive: true });
  on(stage, 'touchend',   function (e) {
    var diff = swipeStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 44) goTo(diff > 0 ? current + 1 : current - 1);
  });

  /* Keyboard arrow nav when focused on gallery */
  on(document, 'keydown', function (e) {
    if (qs('#rp-lightbox.rp-lightbox--open')) return; /* handled by lightbox */
    if (e.key === 'ArrowLeft')  goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  /* ═══════════════════════════════════
     2. LIGHTBOX
  ═══════════════════════════════════ */
  var lightbox = qs('#rp-lightbox');
  var lbImg    = qs('#rp-lb-img');
  var lbCount  = qs('#rp-lb-count');

  function openLightbox() {
    if (!lightbox) return;
    var activeImg = qs('.rp-slide--active img');
    if (!activeImg) return;
    lbImg.src = activeImg.dataset.full || activeImg.src;
    lbImg.alt = activeImg.alt;
    if (lbCount) lbCount.textContent = (current + 1) + ' / ' + total;
    lightbox.classList.add('rp-lightbox--open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('rp-lightbox--open');
    document.body.style.overflow = '';
  }

  function lbNavigate(dir) {
    goTo(current + dir);
    var activeImg = qs('.rp-slide--active img');
    if (activeImg && lbImg) lbImg.src = activeImg.dataset.full || activeImg.src;
  }

  on(stage, 'click', function (e) { if (e.target.tagName === 'IMG') openLightbox(); });
  on(qs('#rp-lb-close'),    'click', closeLightbox);
  on(qs('#rp-lightbox'),    'click', function (e) { if (e.target.id === 'rp-lb-backdrop') closeLightbox(); });
  on(qs('#rp-lb-backdrop'), 'click', closeLightbox);
  on(qs('#rp-lb-prev'),     'click', function () { lbNavigate(-1); });
  on(qs('#rp-lb-next'),     'click', function () { lbNavigate(1);  });

  on(document, 'keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('rp-lightbox--open')) return;
    if (e.key === 'Escape')      closeLightbox();
    if (e.key === 'ArrowLeft')   lbNavigate(-1);
    if (e.key === 'ArrowRight')  lbNavigate(1);
  });

  /* ═══════════════════════════════════
     3. QUANTITY STEPPER
  ═══════════════════════════════════ */
  var qtyInput = qs('#rp-qty');

  function changeQty(delta) {
    if (!qtyInput) return;
    var val = parseInt(qtyInput.value, 10) + delta;
    qtyInput.value = Math.max(1, Math.min(99, val));
  }

  on(qs('#rp-dec'), 'click', function () { changeQty(-1); });
  on(qs('#rp-inc'), 'click', function () { changeQty(1); });

  /* ═══════════════════════════════════
     4. ADD TO CART — AJAX
  ═══════════════════════════════════ */
  var form      = qs('#rp-form');
  var atcBtn    = qs('#rp-atc');
  var atcLabel  = qs('#rp-atc-label');
  var variantId = qs('#rp-variant-id');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;

      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var vid = variantId ? variantId.value : null;
      if (!vid) return;

      /* loading state */
      atcBtn.classList.add('rp-atc--loading');
      if (atcLabel) atcLabel.textContent = 'Adding…';
      if (stickyLabel) stickyLabel.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        /* success feedback */
        atcBtn.classList.remove('rp-atc--loading');
        if (atcLabel) atcLabel.textContent = '✓ Added!';
        if (stickyLabel) stickyLabel.textContent = '✓ ADDED!';
        setTimeout(function () {
          if (atcLabel) atcLabel.textContent = 'Add to Cart';
          if (stickyLabel) stickyLabel.textContent = 'ADD TO CART';
        }, 2000);

        /* refresh cart count badges */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            qsa('.js-cart-count').forEach(function (el) {
              el.textContent  = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          });

        /* open cart drawer — refresh FIRST so items render, then open */
        if (window.CartDrawer) {
          window.CartDrawer.refresh().then(function () {
            window.CartDrawer.open();
          });
        } else {
          /* fallback: click the open-cart trigger if CartDrawer global not available */
          var openCartBtn = qs('.js-open-cart');
          if (openCartBtn) {
            /* refresh manually then open */
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function () { openCartBtn.click(); });
          }
        }
      })
      .catch(function () {
        atcBtn.classList.remove('rp-atc--loading');
        if (atcLabel) atcLabel.textContent = 'Add to Cart';
        form.submit(); /* fallback to full-page submit */
      });
    });
  }

  /* ═══════════════════════════════════
     5. BUY NOW
  ═══════════════════════════════════ */
  on(qs('#rp-buynow'), 'click', function () {
    var vid = variantId ? variantId.value : null;
    var qty = qtyInput  ? qtyInput.value  : 1;
    if (vid) window.location.href = '/cart/' + vid + ':' + qty + '?checkout';
  });

  /* ═══════════════════════════════════
     6. VARIANT SWITCHING
  ═══════════════════════════════════ */
  var variantsData = [];
  try {
    var json = qs('#rp-variants-json');
    if (json) variantsData = JSON.parse(json.textContent);
  } catch (e) {}

  function getSelections() {
    var sel = {};
    qsa('.rp-swatches').forEach(function (sw) {
      var active = qs('.rp-swatch--active', sw);
      if (active) sel[sw.dataset.option] = active.dataset.value;
    });
    return sel;
  }

  function findVariant(selections) {
    return variantsData.find(function (v) {
      return Object.keys(selections).every(function (pos) {
        return v['option' + pos] === selections[pos];
      });
    });
  }

  qsa('.rp-swatch').forEach(function (btn) {
    on(btn, 'click', function () {
      if (btn.classList.contains('rp-swatch--sold')) return;

      var optionGroup = btn.closest('.rp-swatches');
      qsa('.rp-swatch', optionGroup).forEach(function (s) {
        s.classList.remove('rp-swatch--active');
        s.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('rp-swatch--active');
      btn.setAttribute('aria-pressed', 'true');

      /* update label */
      var pos = btn.dataset.option;
      var labelEl = qs('#rp-opt-val-' + pos);
      if (labelEl) labelEl.textContent = btn.dataset.value;

      /* find matched variant */
      var matched = findVariant(getSelections());
      if (!matched) return;

      /* update hidden variant id */
      if (variantId) variantId.value = matched.id;

      /* update price */
      var priceEl    = qs('#rp-price');
      var compareEl  = qs('#rp-compare-price');
      var saveEl     = qs('#rp-save-badge');
      var stickyPrice= qs('#rp-sticky-price');

      if (priceEl) {
  priceEl.textContent = money(matched.price);
}

if (stickyPrice) {
  stickyPrice.textContent = money(matched.price);
}

if (matched.compare_at_price > matched.price) {

  if (compareEl) {
    compareEl.textContent = money(matched.compare_at_price);
    compareEl.style.display = '';
  }

  var savePct = Math.round(
    ((matched.compare_at_price - matched.price) / matched.compare_at_price) * 100
  );

  if (saveEl) {
    saveEl.textContent = 'Save ' + savePct + '%';
    saveEl.style.display = '';
  }

} else {

  if (compareEl) {
    compareEl.style.display = 'none';
  }

  if (saveEl) {
    saveEl.style.display = 'none';
  }

}

      /* availability */
      if (atcBtn) {
        var available = matched.available;
        atcBtn.disabled = !available;
        atcBtn.classList.toggle('rp-atc--soldout', !available);
        if (atcLabel) atcLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
      var buyNow = qs('#rp-buynow');
      if (buyNow) buyNow.disabled = !matched.available;
      updateStickyLabel(matched.available);

      /* jump to variant image */
      if (matched.featured_image) {
        var targetSrc = matched.featured_image.src.split('?')[0];
        slides.forEach(function (sl, i) {
          var img = qs('img', sl);
          if (img && img.src.split('?')[0].indexOf(targetSrc.split('/').pop().split('.')[0]) > -1) {
            goTo(i);
          }
        });
      }

      /* update URL without reload */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({ variantId: matched.id }, '', url.toString());
      }
    });
  });

  /* ═══════════════════════════════════
     7. STICKY ATC BAR (mobile)
  ═══════════════════════════════════ */
  var stickyBar     = qs('#rp-sticky');
  var stickyQtyNum  = qs('#rp-sticky-qty');
  var stickyLabel   = qs('#rp-sticky-label');

  /* Always visible on mobile — no IntersectionObserver needed */
  /* Sync sticky qty with main qty stepper */
  function syncStickyQty(val) {
    if (stickyQtyNum) stickyQtyNum.textContent = val;
  }

  /* Override main qty buttons to also sync sticky */
  var origDec = qs('#rp-dec');
  var origInc = qs('#rp-inc');
  if (origDec) origDec.addEventListener('click', function () {
    setTimeout(function () { if (qtyInput) syncStickyQty(qtyInput.value); }, 0);
  });
  if (origInc) origInc.addEventListener('click', function () {
    setTimeout(function () { if (qtyInput) syncStickyQty(qtyInput.value); }, 0);
  });

  /* Sticky qty buttons */
  on(qs('#rp-sticky-dec'), 'click', function () {
    if (!qtyInput) return;
    var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    qtyInput.value = v; syncStickyQty(v);
  });
  on(qs('#rp-sticky-inc'), 'click', function () {
    if (!qtyInput) return;
    var v = Math.min(99, parseInt(qtyInput.value, 10) + 1);
    qtyInput.value = v; syncStickyQty(v);
  });

  /* Sticky ATC click — trigger main form submit */
  qsa('.js-rp-sticky-atc').forEach(function (btn) {
    on(btn, 'click', function () {
      if (atcBtn && !atcBtn.disabled) atcBtn.click();
    });
  });

  /* Update sticky label when variant changes availability */
  function updateStickyLabel(available) {
    if (stickyLabel) stickyLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    var stickyAtcBtn = qs('#rp-sticky-atc-btn');
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = !available;
      stickyAtcBtn.style.background = available ? '' : 'var(--rp-sand)';
      stickyAtcBtn.style.color = available ? '' : 'var(--rp-text-mid)';
    }
  }

  /* ═══════════════════════════════════
     8. TABS
  ═══════════════════════════════════ */
  var tabBtns   = qsa('.rp-tab');
  var tabPanels = qsa('.rp-tab-panel');

  tabBtns.forEach(function (tab) {
    on(tab, 'click', function () {
      var target = tab.dataset.tab;
      tabBtns.forEach(function (t) {
        t.classList.toggle('rp-tab--active', t.dataset.tab === target);
        t.setAttribute('aria-selected', t.dataset.tab === target ? 'true' : 'false');
      });
      tabPanels.forEach(function (panel) {
        panel.classList.toggle('rp-tab-panel--active', panel.dataset.panel === target);
      });
    });
  });

  /* ═══════════════════════════════════
     9. FAQ ACCORDION
  ═══════════════════════════════════ */
  qsa('.rp-faq__q').forEach(function (btn) {
    on(btn, 'click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      /* close others */
      qsa('.rp-faq__q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var wrap = b.nextElementSibling;
        if (wrap) wrap.style.maxHeight = '0';
      });
      /* open clicked if it was closed */
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        var wrap = btn.nextElementSibling;
        if (wrap) wrap.style.maxHeight = wrap.scrollHeight + 'px';
      }
    });
  });

  /* ═══════════════════════════════════
     10. ANIMATE REVIEW BARS ON SCROLL
  ═══════════════════════════════════ */
  var barFills = qsa('.rp-bar__fill');
  if (barFills.length) {
    /* set initial 0 width */
    barFills.forEach(function (b) {
      b.dataset.target = b.style.width;
      b.style.width = '0';
    });
    var barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          barFills.forEach(function (b) { b.style.width = b.dataset.target; });
          barIO.disconnect();
        }
      });
    }, { threshold: 0.4 });
    var reviewSection = qs('#rp-reviews');
    if (reviewSection) barIO.observe(reviewSection);
  }

})();


/* ===========================
   PRODUCT ACCORDION
=========================== */

document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".rp-item");

  items.forEach((item) => {

    item.addEventListener("toggle", function () {

      if (this.open) {

        items.forEach((other) => {

          if (other !== this) {
            other.removeAttribute("open");
          }

        });

      }

    });

  });

});